import { IAuthorizationSelector } from "./typing/authorization.interface";
import { RootState } from "../../store/rootStore";
import { createSelector } from "reselect";

const selectRawDataAuthorization = (state: RootState) => state.authorization;

// Create a memoized selector using reselect
export const AuthorizationSelector = createSelector(
  [selectRawDataAuthorization],
  ({ authorizationModal, redirect }) => {
    return {
      open: authorizationModal,
      redirect,
    } as IAuthorizationSelector;
  }
);
